import { useFirestoreGeneralOrderBy, useFirestoreGeneralTwoOrderBy } from "../../firebase/useFirestore.js";

const MeasureMomentTasksCounter = ({measureMomentId = '', personaID = ''}) => {

  // Firestore
  const tasksAll = useFirestoreGeneralOrderBy('Tasks', 'MeasureMomentID', measureMomentId, 'Position', 'asc');
  const tasksFiltered = useFirestoreGeneralTwoOrderBy('Tasks', 'MeasureMomentID', measureMomentId, 'PersonaID', personaID, 'Position', 'asc');

  const tasks = personaID ? tasksFiltered : tasksAll

  return (
    <>
     {tasks ? tasks.length : 0} gepland
    </>
  )
}

export default MeasureMomentTasksCounter